import { Trans } from '@lingui/react'
import { number } from 'prop-types'
import { connectStats } from 'react-instantsearch-dom'

const Stats = ({ nbHits }) => (
  <Trans
    id="general.label.showResults"
    values={{
      count: nbHits,
    }}
  />
)

Stats.propTypes = {
  nbHits: number.isRequired,
}

export default connectStats(Stats)
